import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import Leftside from "../Landing_page/Left_sidebar/Leftside";
import Rightside from "../Landing_page/Right_sidebar/Rightside";
import { PostCard } from "./PostCard";
import styles from "./profile.module.css";

export const Bookmarks = () => {
    const [bookmarks, setBookmarks] = useState([]);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        axios.get(`${url}/posts/bookmarks/${loggedInUser._id}`)
            .then((res) => {
                // console.log(res.data);
                setBookmarks(res.data.posts);
            })
            .catch((err) => {
                alert(err);
            })
    },[])
    return (
        <div>
            <div style={{ display: "flex", paddingTop:"15px", maxWidth:"100%",justifyContent:"space-between", backgroundColor:"rgb(245,247,250)", overflowY:"hidden" }}>
                <Leftside />
                <div style={{minWidth:"230px"}}></div>
            <div style={{ display: "flex", width:"50%", flexDirection:"column", backgroundColor:"rgb(245,247,250)" }}>
                {/* <Articlepage />
                <Myfeed/> */}
                    <div style={{ backgroundColor:"white", width: "104.5%", height: "138px", borderRadius: "5px", border: "1px solid #e6e3e3", display:"flex", alignItems:"center", flexDirection:"column"}}>
                        <h3 style={{marginBottom:"6px", fontSize: "30px", color: "#292828" }}>Bookmarks</h3>
                        <span style={{color:"#5c5858"}}>All the discussions, stories and comments you have bookmarked on Hashnode.</span>
                        
                    </div>
            <PostCard posts={bookmarks} />
            </div>
            <Rightside style={{ border:"2px solid red" }}/>
        </div>
        </div>
    )
}